import PropTypes from "prop-types";

import GroupExportTool from "./GroupExportTool";

const SsoAudits = ({ exportableGroups }) => 
  <div className="user-content">
    <div className="content-wrap">
      <div className="container">
        <div className="row">
          <div className="panel">
            <div className="panel-header">
              SSO Audits
            </div>

            <div className="panel-body">
              <GroupExportTool exportableGroups={exportableGroups} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

SsoAudits.propTypes = {
  exportableGroups: PropTypes.arrayOf(PropTypes.shape()).isRequired,
}

export default SsoAudits;
